import { Col, Divider, Row, Space, Button, Flex, Card } from "antd";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Info, InfoSwitch } from "components/elements";

import {
  formatDayMonth,
  formatDays,
  formatTimes,
  formatYears,
} from "utils/formatter";
import styles from "../styles/CompanyProfile.module.css";
import { ReactComponent as EditIcon } from "../../../assets/images/edit.svg"

function CompanyWorkingView({ currentWorking = {}, onEdit = () => { } }) {
  const { t, i18n } = useTranslation();
  const { roles } = useSelector((state) => state.company);
  const { shiftConditionChange = {} } = currentWorking;

  return (
    <Space className={styles.container} size={24} direction="vertical">
      {
        roles.includes("UPDATE_CONFIGURATION|COMPANY_SETTING|CONDITION") && <Row justify="end">
          <Button type="primary" onClick={onEdit} style={{ width: "max-content", height: "44px", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "8px 16px", color: "white" }}>
            <Flex align="center" justify="center" gap={8}>
              <EditIcon />
              {t("common.edit").toUpperCase()}
            </Flex>
          </Button>
        </Row>
      }

      <Card style={{ border: "solid 1px #EAECF0" }}>
        <b className={styles.infoTopic}>
          {t("working_condition.label.working_hours_and_statuses")}
        </b>
        <p>{t("working_condition.label.description1")}</p>
        <Divider />
        <Row gutter={[24, 24]}>
          <Col span={12}>
            <Info
              label={t("working_condition.label.working_hours")}
              value={formatTimes(currentWorking.workingHours)}
            />
          </Col>
          <Col span={12}>
            <Info
              label={t("working_condition.label.year_end_date")}
              value={formatDayMonth(currentWorking.yearEndDate)}
            />
          </Col>
          <Col span={12}>
            <InfoSwitch
              label={t("working_condition.label.based_working_in_shift")}
              value={currentWorking.baseOnShifts === "Y"}
              disabled
            />
          </Col>
          <Col span={12}>
            <InfoSwitch
              label={t("working_condition.label.clock_out_by_shift")}
              value={currentWorking.checkOutByLocation === "Y"}
              disabled
            />
          </Col>
          <Col span={12}>
            <Info
              label={t("working_condition.label.mark_late")}
              value={formatTimes(currentWorking.lateTime)}
            />
          </Col>
          <Col span={12}>
            <Info
              label={t("working_condition.label.mark_absent")}
              value={formatTimes(currentWorking.absentTime)}
            />
          </Col>
        </Row>
      </Card>
      <Card style={{ border: "solid 1px #EAECF0" }}>
        <b className={styles.infoTopic}>{t("working_condition.label.shift")}</b>
        <p>{t("working_condition.label.description2")}</p>
        <Divider />
        <Row gutter={[24, 24]}>
          <Col span={12}>
            <Info
              label={t("working_condition.label.condition_shift_change")}
              value={
                i18n.language === "en"
                  ? shiftConditionChange.nameEn
                  : shiftConditionChange.name
              }
            />
          </Col>
          <Col span={12}>
            <Info
              label={t("working_condition.label.backdate_within")}
              value={
                currentWorking.shiftDateChange
                  ? formatDays(+currentWorking.shiftDateChange)
                  : "-"
              }
            />
          </Col>
          <Col span={12}>
            <InfoSwitch
              label={t("working_condition.label.shift_changable")}
              value={currentWorking.supvAnyTimeShiftChange === "Y"}
              disabled
            />
          </Col>
          <Col span={12}>
            <InfoSwitch
              label={t("working_condition.label.only_normal_employee")}
              value={currentWorking.onlyEmployeeNormalStatus === "Y"}
              disabled
            />
          </Col>
        </Row>
      </Card>
      <Card style={{ border: "solid 1px #EAECF0" }}>
        <b className={styles.infoTopic}>
          {t("working_condition.label.probation")}
        </b>
        <p>{t("working_condition.label.description3")}</p>
        <Divider />
        <Row gutter={[24, 24]}>
          <Col span={12}>
            <Info
              label={t("working_condition.label.prorate_if_before")}
              value={
                currentWorking.prorateLeaveIfBefore
                  ? formatDays(+currentWorking.prorateLeaveIfBefore)
                  : "-"
              }
            />
          </Col>
          <Col span={12}>
            <Info
              label={t("working_condition.label.days_of_probation")}
              value={
                currentWorking.dayOfProbation
                  ? formatDays(+currentWorking.dayOfProbation)
                  : "-"
              }
            />
          </Col>
          <Col span={12}>
            <InfoSwitch
              label={t("working_condition.label.allow_half_prorate_from")}
              value={currentWorking.halfProrateFromDay === "Y"}
              disabled
            />
          </Col>
        </Row>
      </Card>
      <Card style={{ border: "solid 1px #EAECF0" }}>
        <b className={styles.infoTopic}>
          {t("working_condition.label.retire")}
        </b>
        <p>{t("working_condition.label.description4")}</p>
        <Divider />
        <Row gutter={[24, 24]}>
          <Col span={12}>
            <Info
              label={t("working_condition.label.male_retriement")}
              value={
                currentWorking.maleRetirementAge
                  ? formatYears(+currentWorking.maleRetirementAge)
                  : "-"
              }
            />
          </Col>
          <Col span={12}>
            <Info
              label={t("working_condition.label.female_retriement")}
              value={
                currentWorking.femaleRetirementAge
                  ? formatYears(+currentWorking.femaleRetirementAge)
                  : "-"
              }
            />
          </Col>
        </Row>
      </Card>
      <Card style={{ border: "solid 1px #EAECF0" }}>
        <b className={styles.infoTopic}>
          {t("working_condition.label.separation")}
        </b>
        <p>{t("working_condition.label.description5")}</p>
        <Divider />
        <Row gutter={[24, 24]}>
          <Col span={12}>
            <Info
              label={t("working_condition.label.count_as_last_month")}
              value={
                currentWorking.countLastMonthBeforeLastWorkday
                  ? formatDays(+currentWorking.countLastMonthBeforeLastWorkday)
                  : "-"
              }
            />
          </Col>
        </Row>
      </Card>
    </Space>
  );
}

export default CompanyWorkingView;
